import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styles from "./NoteCreationPanel.module.css";
import { useApi, useTrackEvent } from "../../../../../../common/hooks";
import { NotesService } from "../../../../../../api";
import { setIsGenerating } from "../../../../slice/note/note-slice";
import AICreationContent from "../ai-creation-dialog/AICreationContent";

const NoteCreationPanel = () => {
	const { call: saveNoteAgentConfig } = useApi(NotesService.saveNoteAgentConfig);
	const { call: createAI } = useApi(NotesService.createAI);
	const projectId = useSelector(({ context }) => context.project.id);

	const trackEvent = useTrackEvent();
	const dispatch = useDispatch();

	const handleLaunchNoteCreation = ({
		integrationPolicy,
		documents,
		additionPrompt,
		selectDocumentAutomatically,
	}) => {
		saveNoteAgentConfig(
			{ projectId },
			{
				integrationPolicy,
				documents,
				additionPrompt,
				selectDocumentAutomatically,
			}
		).then(() => {
			trackEvent("Notes_New_AI_Note");
			createAI({ projectId });
			dispatch(setIsGenerating(true));
		});
	};
	return (
		<div className={styles.container}>
			<AICreationContent onSubmit={handleLaunchNoteCreation} />
		</div>
	);
};

export default NoteCreationPanel;
